import styled from 'styled-components/macro'
import { em, color } from '../../../utils/styles'

const FormError = styled.p`
  font-size: .875em;
  border-left: 3px solid ${color('error')};
  border-right: 3px solid ${color('error')};
  padding: 0 1em;
  margin: ${em(30)} 0;
  color: ${color('error')};
  text-align: center;
`

export default FormError
